import Vue from 'vue'
import api from '@/api'
import c from '@/config'
import storejs from 'store'
import { PromiseAll } from '@/utils/utils'

function initCache() {
  const cache = storejs.get('preloading:cached') || {}
  Object.keys(cache).forEach(key => {
    if (cache[key] === 'pending') {
      cache[key] = undefined
    }
  })
  return cache
}

const state = {
  cameraListJob: [], // tarURL
  cameraDataJob: [], // tarURL, cameraId

  cached: initCache(), // mark cached item
}

const getters = {}

const mutations = {
  addCameraListJob(state, job) {
    state.cameraListJob = state.concat(job)
  },
  addCameraDataJob(state, job) {
    state.cameraListJob = state.concat(job)
  },
}

const actions = {
  preFetchCameraList({ state, rootState, rootGetters }) {
    const tarList = rootGetters['search/filteredTarList']
    if (rootGetters.tarUrl) {
      // 直接从搜索列表中拿取下一项
      const index = tarList.findIndex(
        item => item.ossPath === rootGetters.tarUrl,
      )
      // const index = tarList.findIndex(item => item.ossPath === rootState.tarUrl)
      if (index !== -1) {
        if (index < tarList.length - 1) {
          const tarUrl = tarList[index + 1].ossPath
          api.getCameraList({ tarUrl }).then(({ data }) => {
            // 继续预加载第一个摄像头数据
            const cameraIds = data.cameraIds
            if (cameraIds.length > 0) {
              api
                .getCameraData({
                  tarUrl: tarUrl,
                  cameraId: cameraIds[0],
                  bitrateInMbps: c.defaultVideoBitRate,
                })
                .then(({ data }) => {
                  api.getFileContent(data.videoUrl).then(() => {
                    Vue.set(state.cached, rootGetters.tarUrl, 'cached')
                  })
                })
            }
          })
        }
        return
      }
    }
    // 从搜索列表中拿第一项
    if (tarList.length > 0) {
      api.getCameraList({ tarUrl: tarList[0].ossPath })
    }
  },
  preFetchCameraData({ rootState, rootGetters }) {
    if (
      rootState.cameraList.length > 1 &&
      rootState.cameraIdx < rootState.cameraList.length - 1
    ) {
      api
        .getCameraData({
          tarUrl: rootGetters.tarUrl,
          cameraId: rootState.cameraList[rootState.cameraIdx + 1],
          bitrateInMbps: c.defaultVideoBitRate,
        })
        .then(({ data }) => {
          api.getFileContent(data.videoUrl).then(() => {
            Vue.set(state.cached, rootGetters.tarUrl, 'cached')
          })
        })
    }
  },
  preload({ state }, tarUrl) {
    return new Promise((resolve, reject) => {
      Vue.set(state.cached, tarUrl, 'pending')
      api
        .getCameraList({ tarUrl })
        .then(({ data }) => {
          // 继续预加载所有摄像头数据
          const cameraIds = data.cameraIds
          if (cameraIds.length > 0) {
            PromiseAll(
              cameraIds.map(id =>
                api
                  .getCameraData({
                    tarUrl: tarUrl,
                    cameraId: id,
                    bitrateInMbps: c.defaultVideoBitRate,
                  })
                  .then(({ data }) => api.getFileContent(data.videoUrl)),
              ),
            )
              .then(() => {
                Vue.set(state.cached, tarUrl, 'cached')
              })
              .catch(() => {
                Vue.set(state.cached, tarUrl, 'failed')
              })
          }
        })
        .catch(() => {
          Vue.set(state.cached, tarUrl, 'failed')
        })
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
